<template>
  <div>
    <div>
      <div class="item">
        <span class="title">消耗时间</span>
        <el-date-picker
          v-model="date"
          :picker-options="expireTimeOption"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">新用户充值时间</span>
        <el-date-picker
          v-model="dates"
          type="daterange"
          :picker-options="expireTimeOption"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <div class="item">
        <span class="title">关系类型</span>
        <el-select
          v-model="appType"
          style="margin-right: 20px"
          placeholder="请选择关系类型"
          filterable
          :clearable="true"
          :disabled="is_select"
          @clear="appType = null"
        >
          <el-option
            v-for="item in [{ 'type': 1, 'label': '公众号' }, { 'type': 2, 'label': '推广链' }]"
            :key="item.type"
            :label="item.label"
            :value="item.type"
          />
        </el-select>
      </div>
      <div v-if="appType === 1">
        <div class="item">
          <span class="title">主公众号</span>
          <el-autocomplete
            v-model="parameterNames.master_appid_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @clear="(parameterNames.master_appid_name = null),(parameter.master_appid = null)"
            @focus="current = '主公众号'"
            @select="handleSelect"
          />
        </div>

        <div class="item">
          <span class="title">副公众号</span>
          <div>
            <el-input
              v-model="multipleSub"
              style="width:150px"
              placeholder="请输入多个的名字"
              @input="($event)=>{multipleSub= handleParams($event)}"
            />
            <el-button type="primary" style="margin-left:10px" @click="multipleSubOfficialAccount()">选中多个</el-button>
          </div>
        </div>
        <div class="checkBox">
          <span class="checkBox_title">选中的公众号</span>
          <div class="checkBox_content">
            <el-tag
              v-for="item in officialObj"
              :key="item.value"
              class="content_item"
              style="margin: 5px;"
              size="small"
            >
              {{ item.label }}
              <i
                class="el-icon-close"
                style="font-size: 18px;"
                @click="deleteOfficialAccount(item)"
              /></el-tag>
          </div>

        </div>
      </div>
      <div v-if="appType === 2">
        <div class="item">
          <span class="title">推广链</span>
          <el-autocomplete
            v-model="parameterNames.popid_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @clear="(parameterNames.popid_name = null),(parameter.popid = null)"
            @focus="current = '主推广链'"
            @select="handleSelect"
          />
        </div>

        <div class="item">
          <span class="title">副推广链</span>
          <div>
            <el-input
              v-model="multipleSub3"
              style="width:150px"
              placeholder="请输入副推广链"
              @input="($event)=>{multipleSub3= handleParams($event)}"
            />
            <el-button type="primary" style="margin-left:10px" @click="multipleSubOfficialAccount(1)">选中多个</el-button>
          </div>
        </div>
        <div class="checkBox">
          <span class="checkBox_title">选中的副推广链</span>
          <div class="checkBox_content">
            <el-tag
              v-for="item in popularizeValue"
              :key="item"
              class="content_item"
              style="margin: 5px;"
              size="small"
            >
              {{ item }}
              <i
                class="el-icon-close"
                style="font-size: 18px;"
                @click="deletePopularize(item)"
              /></el-tag>
          </div>

        </div>
      </div>
      <div class="item">
        <span class="title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.release_group_id_name = null),(parameter.release_group_id = null)"
          @focus="current = '投放组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.pitcher_id_name = null),(parameter.pitcher_id = null)"
          @focus="current = '投手'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">运营组</span>
        <el-autocomplete
          v-model="parameterNames.operation_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.operation_group_id_name = null),(parameter.operation_group_id = null)"
          @focus="current = '运营组'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">运营者</span>
        <el-autocomplete
          v-model="parameterNames.operation_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.operation_id_name = null),(parameter.operation_id = null)"
          @focus="current = '运营者'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">短剧</span>
        <el-autocomplete
          v-model="parameterNames.alias_book_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @clear="(parameterNames.alias_book_id_name = null),(parameter.alias_book_id = null)"
          @focus="current = '短剧'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">投放位置</span>
        <el-autocomplete
          v-model="parameterNames.position_id_name"
          :fetch-suggestions="querySearchAsync"
          :clearable="true"
          placeholder="请输入内容"
          @clear="(parameterNames.position_id_name = null),(parameter.position_id = null)"
          @focus="current = '投放位置'"
          @select="handleSelect"
        />
      </div>

      <div class="item">
        <span class="title">广告主</span>
        <div>
          <el-input
            v-model="multipleSub1"
            style="width:150px"
            placeholder="请输入多个的名字"
            @input="($event)=>{multipleSub1= handleParams($event)}"
          />
          <el-button type="primary" style="margin-left:10px" @click="multipleSubAdvertiser(1)">选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的广告主</span>
        <div class="checkBox_content">
          <el-tag
            v-for="item in advertiserObj"
            :key="item.value"
            class="content_item"
            style="margin: 5px;"
            size="small"
          >{{ item.label }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteAdvertiser(item)"
            />
          </el-tag>
        </div>
      </div>
      <div class="item">
        <span class="title">巨量广告</span>
        <div>
          <el-input
            v-model="multipleSub2"
            style="width:150px"
            placeholder="请输入多个的名字"
            @input="($event)=>{multipleSub2= handleParams($event)}"
          />
          <el-button type="primary" style="margin-left:10px" @click="multipleSubAdvertiser(2)">选中多个</el-button>
        </div>
      </div>
      <div class="checkBox">
        <span class="checkBox_title">选中的巨量广告</span>
        <div class="checkBox_content">
          <el-tag
            v-for="item in oceanAdObj"
            :key="item.value"
            class="content_item"
            style="margin: 5px;"
            size="small"
          >{{ item.label }}
            <i
              class="el-icon-close"
              style="font-size: 18px;"
              @click="deleteoceanAd(item)"
            />
          </el-tag>
        </div>
      </div>

      <div class="item">
        <span class="title">平台id</span>
        <el-select
          v-model="parameter.platform_id"
          style="margin-right: 20px"
          placeholder="请选择平台"
          filterable
          :clearable="true"
          @clear="parameter.platform_id = null"
        >
          <el-option
            v-for="(item, index) in platformSelectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
    </div>

    <div style="text-align: end; margin-top:20px">
      <el-button class="" type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getTheListOfOfficialAccount, getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getOperationGroupList, getOperatorList, getShortPlayList, dropLocationList, getAdvertiser, getPlatform } from '@/api/shortPlayReport.js'
export default {
  props: {
    drawerItem: {
      type: Object,
      default() {
        return {

        }
      }
    }
  },
  data() {
    return {
      expireTimeOption: {
        disabledDate(date) {
          return (
            date.getTime() < new Date(new Date().getFullYear(), 0, 1).getTime() ||
            date.getTime() > new Date(new Date().getFullYear(), 11, 31).getTime()
          )
        }
      },

      parameter: {
        master_appid: null, // 主公众号
        popid: null, // 推广链
        release_group_id: null, // 投放组
        pitcher_id: null, // 投手
        operation_group_id: null, // 运营组
        operation_id: null, // 运营者
        alias_book_id: null, // 短剧
        position_id: null, // 投放位置
        platform_id: null // 平台
      },
      parameterNames: {
        master_appid_name: null, // 主公众号
        popid_name: null,
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 短剧
        position_id_name: null, // 投放位置
        app_id_name: null // 平台
      },

      is_select: false, // 关系类型下拉框
      current: null,
      loading: false,
      loading1: false,
      date: [],
      dates: [],
      platformSelectList: [], // 平台列表
      appType: null, // 关系类型

      popularizeValue: [], // 副推广链id接口请求提交参数

      officialValue: [], // 副公众号接口请求提交参数
      fromOfficialAccount: [], // 副公众号
      officialObj: [], // 副公众号tag列表

      advertiserValue: [], // 广告主值接口请求提交参数

      oceanAdValue: [], // 巨量值接口请求提交参数
      fromoOceanAd: [], // 巨量
      oceanAdObj: [], // 巨量tag列表

      multipleSub: null, // 输入的多个从公众号的名字
      multipleSub3: null, // 输入的多个副推广链的名字
      multipleSub1: null, // 输入的多个广告主的名字
      multipleSub2: null, // 输入的多个巨量的名字
      advertiserObj: []
    }
  },
  created() {
    window.aaa = this
    this.myGetchannelplatform() // 获取平台
    this.init()
  },
  mounted() {
  },
  methods: {

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '主公众号' : this.parameter.master_appid = item
          break
        case '主推广链' : this.parameter.popid = item
          break
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        case '运营组' : this.parameter.operation_group_id = item
          break
        case '运营者' : this.parameter.operation_id = item
          break
        case '短剧' : this.parameter.alias_book_id = item
          break
        case '投放位置' : this.parameter.position_id = item
          break
      }
    },
    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '主公众号': 'account_name',
        '主推广链': 'app_id',
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '运营组': 'operation_group_name',
        '运营者': 'user_name',
        '投放位置': 'position_name'
      }

      switch (this.current) {
        case '主公众号': currentFunc = getTheListOfOfficialAccount
          break
        case '主推广链': currentFunc = getTheListOfOfficialAccount
          break
        case '投放组': currentFunc = getReleaseGroupList
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组': currentFunc = getOperationGroupList
          break
        case '运营者': currentFunc = getOperatorList
          break
        case '短剧': currentFunc = getShortPlayList
          break
        case '投放位置': currentFunc = dropLocationList
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '运营者' && !this.parameter.operation_group_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '运营者': '请先选运营组，才能选运营者'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        type: this.current === '主推广链' ? 1 : null,
        page: this.current === '短剧' ? 1 : null,
        pageSize: this.current === '短剧' ? 10 : null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null
      })
      cb(data.data.list.map((item) => {
        return {
          value: this.current === '短剧' ? item.name + (item.platform ? `（${item.platform}）` : '') : item[obj[this.current]],
          address: this.current === '主公众号' || this.current === '主推广链' ? item.app_id : item.id
        }
      }))
    },

    // 请求平台
    async myGetchannelplatform() {
      const data = await getPlatform({ type: 2 })
      this.platformSelectList = data.data.list
    },
    // 请求初始短剧
    async shortPlay() {
      const data = await getShortPlayList({
        name: this.drawerItem.novel_name,
        page: 1,
        pageSize: 10
      })
      const item = data.data.list[0]
      this.parameterNames.alias_book_id_name = item.name + (item.platform ? `（${item.platform}）` : '')
      this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
        value: this.parameterNames.alias_book_id_name,
        address: this.drawerItem.novel_id
      }
    },

    // 初始化
    init() {
      this.appType = this.drawerItem.type
      if (this.drawerItem.begin_time && this.drawerItem.end_time) {
        // 时间
        this.date[0] = this.drawerItem.begin_time
        this.date[1] = this.drawerItem.end_time
      }
      if (this.drawerItem.recharge_begin && this.drawerItem.recharge_end) {
        // 新用户充值时间
        this.dates[0] = this.drawerItem.recharge_begin
        this.dates[1] = this.drawerItem.recharge_end
      }

      // 短剧
      if (this.drawerItem.id) {
        this.is_select = true
        this.shortPlay()
      } else {
        this.parameterNames.alias_book_id_name = this.drawerItem.short_novel ? this.drawerItem.short_novel : null
        this.parameter.alias_book_id = this.parameterNames.alias_book_id_name && {
          value: this.parameterNames.alias_book_id_name,
          address: this.drawerItem.novel_id
        }
      }
      // 主公众号
      this.parameterNames.master_appid_name = (this.drawerItem.wechat_names && this.drawerItem.wechat_names.length) ? this.drawerItem.wechat_names[0] : null
      this.parameter.master_appid = this.parameterNames.master_appid_name && {
        value: this.drawerItem.wechat_names[0],
        address: this.drawerItem.master_appid
      }
      // 副公众号
      this.officialValue = (this.drawerItem.app_ids && this.drawerItem.app_ids.length) ? [...Object.values(this.drawerItem.app_ids).slice(1)] : []

      this.fromOfficialAccount = this.officialValue.map((item, index) => {
        return {
          value: item,
          label: this.drawerItem.wechat_names[index + 1]
        }
      })

      this.officialObj = this.officialValue.map((item, index) => {
        return {
          value: item,
          label: this.drawerItem.wechat_names[index + 1]
        }
      })
      // 主推广链id
      this.parameterNames.popid_name = this.drawerItem.popId ? this.drawerItem.popId : this.drawerItem.master_appid ? this.drawerItem.master_appid : null
      this.parameter.popid = this.parameterNames.popid_name && (this.drawerItem.popId ? {
        value: this.drawerItem.popId,
        address: this.drawerItem.popId
      } : this.parameter.master_appid)
      // 副推广链
      this.popularizeValue = this.drawerItem.popularize_ids && this.drawerItem.popularize_ids.length ? this.drawerItem.popularize_ids : this.drawerItem.id ? this.officialValue : []

      // 投放组
      this.parameterNames.release_group_id_name = this.drawerItem.release_group_name
      this.parameter.release_group_id = this.parameterNames.release_group_id_name && {
        value: this.drawerItem.release_group_name,
        address: this.drawerItem.release_group_id
      }

      // 投手
      this.parameterNames.pitcher_id_name = this.drawerItem.pitcher_name
      this.parameter.pitcher_id = this.parameterNames.pitcher_id_name && {
        value: this.drawerItem.pitcher_name,
        address: this.drawerItem.pitcher_id
      }

      // 运营组
      this.parameterNames.operation_group_id_name = this.drawerItem.operation_group_name
      this.parameter.operation_group_id = this.parameterNames.operation_group_id_name && {
        value: this.drawerItem.operation_group_name,
        address: this.drawerItem.operation_group_id
      }

      // 运营者
      this.parameterNames.operation_id_name = this.drawerItem.operation_name
      this.parameter.operation_id = this.parameterNames.operation_id_name && {
        value: this.drawerItem.operation_name,
        address: this.drawerItem.operation_id
      }

      // 投放位置
      this.parameterNames.position_id_name = this.drawerItem.position_name
      this.parameter.position_id = this.parameterNames.position_id_name && {
        value: this.drawerItem.position_name,
        address: this.drawerItem.position_id
      }

      // 广告主
      this.advertiserValue = (this.drawerItem.advertiser_ids && this.drawerItem.advertiser_ids.length) ? [...this.drawerItem.advertiser_ids] : []

      this.fromAdvertiser = this.advertiserValue.length ? this.drawerItem.advertiser.map((item, index) => {
        return {
          value: item.account_id,
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []

      this.advertiserObj = this.advertiserValue.length ? this.drawerItem.advertiser.map((item, index) => {
        return {
          value: item.account_id,
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []

      // 巨量广告
      this.oceanAdValue = (this.drawerItem.ocean_advertiser_ids && this.drawerItem.ocean_advertiser_ids.length) ? this.drawerItem.ocean_advertiser_ids.map(id => String(id)) : []
      this.fromoOceanAd = this.oceanAdValue.length ? this.drawerItem.ocean_advertiser.map((item, index) => {
        return {
          value: String(item.account_id), // 强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []
      this.oceanAdObj = this.oceanAdValue.length ? this.drawerItem.ocean_advertiser.map((item, index) => {
        return {
          value: String(item.account_id), // 强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      }) : []
      // 平台
      this.parameter.platform_id = this.drawerItem.platform_id
    },

    // 选中多个副公众号
    async multipleSubOfficialAccount(type) {
      if (!this.multipleSub && !type) {
        this.$message({
          message: '必须输入 公众号id 或 名字',
          type: 'warning'
        })
        return
      }
      if (!this.multipleSub3 && type) {
        this.$message({
          message: '必须输入 推广链id 或 名字',
          type: 'warning'
        })
        return
      }
      // 获取公众号
      const data = await getTheListOfOfficialAccount({ name: type ? this.multipleSub3 : this.multipleSub, type })

      // 判断是否为空
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }

      // 将获取到的公众号变更下字段名

      if (type) {
        const arr = data.data.list.map((item) => {
          return item.app_id
        })

        for (let i = 0; i < arr.length; i++) {
          (this.popularizeValue.indexOf(arr[i]) < 0) && this.popularizeValue.push(arr[i])
        }
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub3, data.data.list, 'app_id')

        this.multipleSub3 = null
      } else {
        let news = data.data.list.map((item) => {
          return {
            value: item.app_id,
            label: item.account_name
          }
        })
        this.fromOfficialAccount = news

        for (let i = 0; i < news.length; i++) {
          (this.officialValue.indexOf(news[i].value) < 0) && this.officialValue.push(news[i].value)
        }

        news = news.map(im => im.value)

        for (let i = 0; i < this.officialValue.length; i++) {
          news.indexOf(this.officialValue[i]) < 0 && news.push(this.officialValue[i])
        }

        this.change(news)

        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub, data.data.list, 'app_id')

        this.multipleSub = null
      }
    },

    handleParams(value) {
      var arr = ''
      const str = /[`~!@#$%^&*()_\ +=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*——\ +={}|《》？：“”【】、；‘'，。、 ]/img
      arr = value.replace(str, ',')

      const str1 = /(,){1,}/img
      arr = arr.replace(str1, ',')
      return arr
    },

    // 选中多个广告主或者巨量
    async multipleSubAdvertiser(type) {
      if (type === 1) {
        if (!this.multipleSub1) {
          this.$message({
            message: '必须输入广告主 id 或 名字',
            type: 'warning'
          })
          return
        }
      } else {
        if (!this.multipleSub2) {
          this.$message({
            message: '必须输入巨量广告 id 或 名字',
            type: 'warning'
          })
          return
        }
      }
      const data = await getAdvertiser({ name: type === 1 ? this.multipleSub1 : this.multipleSub2, type: type })
      if (!data.data.list.length) {
        this.$message({
          message: '筛选为0个，没法选中',
          type: 'warning'
        })
      }
      let news = data.data.list.map((item) => {
        return {
          value: type === 2 ? String(item.account_id) : item.account_id, // 巨量广告强制转换为字符串
          label: `${item.account_name && item.account_id ? item.account_name + '--' : item.account_name}${item.account_id && item.agent_name ? item.account_id + '--' : item.account_id}${item.agent_name || ''}`
        }
      })
      if (type === 1) {
        // 广告主模块
        this.fromAdvertiser = news
        for (let i = 0; i < news.length; i++) {
          (this.advertiserValue.indexOf(news[i].value) < 0) && this.advertiserValue.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.advertiserValue.length; i++) {
          news.indexOf(this.advertiserValue[i]) < 0 && news.push(this.advertiserValue[i])
        }
        this.change1(news)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub1, data.data.list, 'account_id')
        this.multipleSub1 = null
      } else {
        // 巨量广告模块
        this.fromoOceanAd = news
        for (let i = 0; i < news.length; i++) {
          (this.oceanAdValue.indexOf(news[i].value) < 0) && this.oceanAdValue.push(news[i].value)
        }
        news = news.map(im => im.value)
        for (let i = 0; i < this.oceanAdValue.length; i++) {
          news.indexOf(String(this.oceanAdValue[i])) < 0 && news.push(String(this.oceanAdValue[i]))
        }
        this.change2(news)
        data.data.list.length && this.judgeThatOneIsNotSelected(this.multipleSub2, data.data.list, 'account_id')
        this.multipleSub2 = null
      }
    },

    // 选择公众号
    change(items) {
      if (!items.length) {
        this.officialObj = []
        return
      }
      for (let i = 0; i < items.length; i++) {
        const im = items[i]
        const index = this.officialObj.findIndex(itemm => itemm.value === im)
        if (index < 0) {
          this.officialObj.push({
            value: im,
            label: this.fromOfficialAccount[this.fromOfficialAccount.findIndex(itemm => itemm.value === im)].label
          })
        } else {
          this.officialObj = this.officialObj.filter((imm) => {
            return !(items.indexOf(imm.value) < 0)
          })
        }
      }
    },
    change3(items) {
      if (!items.length) {
        this.popularizeObj = []
        return
      }
      for (let i = 0; i < items.length; i++) {
        const im = items[i]
        const index = this.popularizeObj.findIndex(itemm => itemm.value === im)
        if (index < 0) {
          this.popularizeObj.push({
            value: im,
            label: this.fromPopularize[this.fromPopularize.findIndex(itemm => itemm.value === im)].label
          })
        } else {
          this.popularizeObj = this.popularizeObj.filter((imm) => {
            return !(items.indexOf(imm.value) < 0)
          })
        }
      }
    },
    // 选择广告主
    change1(item) {
      for (let i = 0; i < this.advertiserValue.length; i++) {
        const im = this.advertiserValue[i]
        const index = this.advertiserObj.findIndex(itemm => itemm.value === im)
        index < 0 && this.advertiserObj.push({ value: im, label: this.fromAdvertiser[this.fromAdvertiser.findIndex(itemm => itemm.value === im)].label })
      }
      this.advertiserObj = this.advertiserObj.filter((imm) => {
        return !(item.indexOf(imm.value) < 0)
      })
    },
    // 选择巨量
    change2(item) {
      for (let i = 0; i < this.oceanAdValue.length; i++) {
        const im = String(this.oceanAdValue[i]) // 统一转换为字符串
        const index = this.oceanAdObj.findIndex(itemm => String(itemm.value) === im)
        index < 0 && this.oceanAdObj.push({ value: im, label: this.fromoOceanAd[this.fromoOceanAd.findIndex(itemm => String(itemm.value) === im)].label })
      }
      this.oceanAdObj = this.oceanAdObj.filter((imm) => {
        return !(item.indexOf(String(imm.value)) < 0)
      })
    },

    // 删除公众号
    deleteOfficialAccount(item) {
      this.officialObj.splice(this.officialObj.findIndex(im => im.value === item.value), 1)
      this.officialValue.splice(this.officialValue.indexOf(item.value), 1)
    },
    // 删除副推广链id
    deletePopularize(item) {
      // console.log(item)
      this.popularizeValue.splice(this.popularizeValue.indexOf(item), 1)
    },
    // 删除广告主
    deleteAdvertiser(item) {
      this.advertiserObj.splice(this.advertiserObj.findIndex(im => im.value === item.value), 1)
      this.advertiserValue.splice(this.advertiserValue.indexOf(item.value), 1)
    },
    // 删除巨量
    deleteoceanAd(item) {
      this.oceanAdObj.splice(this.oceanAdObj.findIndex(im => String(im.value) === String(item.value)), 1)
      this.oceanAdValue.splice(this.oceanAdValue.indexOf(String(item.value)), 1)
    },

    // 确定
    determine() {
      if (this.judgmentParameters()) {
        const parameter = this.assemblyParameters()
        this.$emit('determine', parameter)
      }
    },

    // 判断参数
    judgmentParameters() {
      // console.log(this.parameter.popid)
      let text = null
      if (((!this.parameter.master_appid || this.parameter.master_appid.value !== this.parameterNames.master_appid_name) && this.appType === 1)) {
        text = '请选择主公众号'
      } else if (((!this.parameter.popid || this.parameter.popid.value !== this.parameterNames.popid_name) && this.appType === 2)) {
        text = '请填写推广链id'
      } else if (!this.parameter.release_group_id || this.parameter.release_group_id.value !== this.parameterNames.release_group_id_name) {
        text = '请选择投放组'
      } else if (!this.parameter.pitcher_id || this.parameter.pitcher_id.value !== this.parameterNames.pitcher_id_name) {
        text = '请选择投手'
      } else if (!this.parameter.operation_group_id || this.parameter.operation_group_id.value !== this.parameterNames.operation_group_id_name) {
        text = '请选择运营组'
      } else if (!this.parameter.operation_id || this.parameter.operation_id.value !== this.parameterNames.operation_id_name) {
        text = '请选择运营者'
      } else if (!this.parameter.alias_book_id || this.parameter.alias_book_id.value !== this.parameterNames.alias_book_id_name) {
        text = '请选择短剧'
      } else if (!this.parameter.position_id || this.parameter.position_id.value !== this.parameterNames.position_id_name) {
        text = '请选择投放位置'
      } else if (!this.advertiserValue.length && !this.oceanAdValue.length) {
        text = '请选择广告主或者巨量广告'
      } else if (!this.parameter.platform_id) {
        text = '请选择平台'
      } else if (!this.date || !this.date.length) {
        text = '请选择日期'
      } else if (!this.dates || !this.dates.length) {
        text = '请选择新用户充值时间'
      }

      text && this.$message({
        message: text,
        type: 'warning'
      })

      return !text
    },

    // 组装参数
    assemblyParameters() {
      const obj = {
        begin_time: this.date[0],
        end_time: this.date[1],
        recharge_begin: this.dates[0],
        recharge_end: this.dates[1],
        master_appid: this.appType === 1 ? this.parameter.master_appid.address : this.parameter.popid.address,
        app_ids: this.appType === 1 ? this.officialValue : this.popularizeValue,
        release_group_id: this.parameter.release_group_id.address,
        pitcher_id: this.parameter.pitcher_id.address,
        operation_group_id: this.parameter.operation_group_id.address,
        novel_id: this.parameter.alias_book_id.address,
        position_id: this.parameter.position_id.address,
        operation_id: this.parameter.operation_id.address,
        advertiser_ids: this.advertiserValue,
        ocean_advertiser_ids: this.oceanAdValue,
        platform_id: this.parameter.platform_id,
        type: this.appType
      }

      return obj
    },

    // 创建渲染回填时想要的结构数据
    createTheDesiredStructure(isL) {
      const obj = !isL ? {
        type: this.appType,
        begin_time: this.date && this.date[0], // 开始时间
        end_time: this.date && this.date[1], // 结束时间
        recharge_begin: this.dates && this.dates[0], // 新用户充值开始时间
        recharge_end: this.dates && this.dates[1], // 新用户充值结束时间
        wechat_names: this.parameterNames.master_appid_name ? [this.parameterNames.master_appid_name, ...this.officialObj.map(item => item.label)] : [...this.officialObj.map(item => item.label)], // 选择的副公众号的值

        master_appid: this.parameter.master_appid && this.parameter.master_appid.address, // 主公众号的id

        app_ids: this.parameter.master_appid ? [this.parameter.master_appid, ...this.officialValue] : [...this.officialValue], // 选中的公众号的id

        popId: this.parameter.popid && this.parameter.popid.address, // 主推广链id
        popularize_ids: this.popularizeValue.length ? this.popularizeValue : [], // 副推广链id

        // 投放组
        release_group_name: this.parameterNames.release_group_id_name,
        release_group_id: this.parameter.release_group_id && this.parameter.release_group_id.address,

        // 投手
        pitcher_id: this.parameter.pitcher_id && this.parameter.pitcher_id.address,
        pitcher_name: this.parameterNames.pitcher_id_name,

        // 运营组
        operation_group_name: this.parameterNames.operation_group_id_name,
        operation_group_id: this.parameter.operation_group_id && this.parameter.operation_group_id.address,

        // 运营者
        operation_name: this.parameterNames.operation_id_name,
        operation_id: this.parameter.operation_id && this.parameter.operation_id.address,

        // 短剧
        short_novel: this.parameterNames.alias_book_id_name,
        novel_id: this.parameter.alias_book_id && this.parameter.alias_book_id.address,

        // 投放位置
        position_name: this.parameterNames.position_id_name,
        position_id: this.parameter.position_id && this.parameter.position_id.address,

        // 平台
        platform_id: this.parameter.platform_id,

        // 广告主
        advertiser_ids: (this.advertiserValue && this.advertiserValue.length) ? this.advertiserValue : [],
        advertiser: (this.advertiserObj && this.advertiserObj.length) ? this.advertiserObj.map((item) => {
          const s = item.label.split('--')
          return {
            account_id: item.value,
            account_name: s[0],
            agent_name: s[s.length - 1]
          }
        }) : [],
        // 巨量广告
        ocean_advertiser_ids: (this.oceanAdValue && this.oceanAdValue.length) ? this.oceanAdValue : [],
        ocean_advertiser: (this.oceanAdObj && this.oceanAdObj.length) ? this.oceanAdObj.map((item) => {
          const s = item.label.split('--')
          return {
            account_id: item.value,
            account_name: s[0],
            agent_name: s[s.length - 1]
          }
        }) : []
      } : {}
      // console.log(obj)
      return obj
    },

    // 判断那个没选中
    judgeThatOneIsNotSelected(texts, arr, idName) {
      const testsr = texts.split(',')
      const unchecked = []
      testsr.forEach((text) => {
        let bool = true
        for (let i = 0; i < arr.length; i++) {
          if (String(arr[i][idName]) === String(text) || String(arr[i].account_name) === String(text)) {
            bool = false
            break
          }
        }
        bool && unchecked.push(text)
      })

      unchecked.length && this.$message({
        message: unchecked.join() + '  没被选中',
        type: 'warning'
      })
    }
  }
}
</script>

<style scoped>
.item{
   display: flex;
   align-items: center;
   margin-bottom: 20px;
}

.item .title{
    display: inline-block;
    width: 110px;
}

.checkBox{
   margin-bottom: 26px;
}

.checkBox_title{

}

.checkBox_content{

}

.content_item{

}
</style>
